import { CONFIG } from "../../config";
import { FunctionClient } from "./FunctionClient";

export const createOrdersClient = new FunctionClient({ baseUrl: CONFIG.CREATE_ORDERS_URL });
export const getOrdersClient = new FunctionClient({ baseUrl: CONFIG.FETCH_ORDERS_URL });
